module.exports = __webpack_public_path__ + "img/pomegrante.3083070.svg";